// This is very similar to string.prototype.matchall, but it seems
// nigh-impossible to get that working with our esnext modules.

export function matchAll(s: string, r: RegExp): RegExpExecArray[] {
  const result: RegExpExecArray[] = [];

  if (!r.global) {
    throw new Error("regular expression must have the global flag set");
  }

  let m: RegExpExecArray | null = null;
  do {
    m = r.exec(s);
    if (m) {
      result.push(m);
    }
  } while (m && m[0]); // Break after empty matches to avoid infinite loops

  return result;
}
